import { Pipe, PipeTransform } from '@angular/core';
import { DomSanitizer } from "@angular/platform-browser";

@Pipe({
  name: 'href'
})
export class HrefPipe implements PipeTransform {
  constructor(
    private sanitizer: DomSanitizer
  ) {
  }
  transform(value: string): string {
    return this.replace(value);
  }
  replace(text) {
    if (typeof text !== 'string') return text;
    text = text.replace(/(^|\s)(@[a-z\d-_]+)/gi, '<a target="_blank" class="userLink" href="tg://user?id=$2">$2</a>');
    text = text.replace(
      /((http|https|ftp):\/\/[\w?=&.\/-;\+#~%-]+(?![\w\s?&.\/;\+#~%"=-]*>))/g,
      '<a href="$1" target="_blank">$1</a>'
    );
    text = text.replaceAll('href=', 'rel="noopener" target="_blank" href=');
    // Replac the RegExp content by HTML element
    return this.sanitizer.bypassSecurityTrustHtml(text);
  }
}
